<template>
  <div>
   <CRow>
      <CCol>
       
        <CCard>
            <CCardHeader>
              <strong>Filter</strong>
            </CCardHeader>

          <CCardBody>
            <form @submit="checkForm" novalidate="true">
             <div class="form-group">

                <CInput id="dateFrom" label="Datum von" type="date" v-model="datePickFrom" horizontal/>
                
                <CInput id="dateTo" label="Datum bis" type="date" v-model="datePickTo" horizontal/>
              
              </div>
              <button type="button" class="btn btn-success" @click="onBtnSubmit">Aktualisieren</button>
            </form>
            </CCardBody>
        </CCard>

        <CTableWrapper
          :items=orderListHistory
          :fields=this.fields
          :items-per-page=100
          hover
          striped
          bordered
          small
          fixed
          sorter
          :reload = false
          caption = "Bestell Historie"
        />
        
          
      </CCol>
    </CRow>
 
  </div>
  
</template>
<script>
  import CTableWrapper from './Table.vue'
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'History',
    components: { CTableWrapper },
    
    
    data() {
      return {

        datePickFrom    : '2020-01-01',
        datePickTo      : '2020-01-30', 

        fields:  [
          {key:'id',label:'#',sorter:true},
          {key:'articleno',label:'Artikel',sorter:true},
          {key:'amount',label:'Menge',sorter:true},
          {key:'status',label:'Status',sorter:true},
          {key:'order_time',label:'Bestelldatum',sorter:true},
          {key:'pod_time',label:'Lieferdatum',sorter:true}
           
        ]        

      };
    },
    computed : mapGetters(["orderListHistory","profile"]),
    created() {
      
        var date = new Date(); 

        var year    = date.getFullYear();
        var month   = ('0' + (date.getMonth()+1)).slice(-2);
                  
        var lastDay =  new Date(year, month + 1, 0);

        this.datePickFrom = year + '-' + month + '-01' ;
        this.datePickTo   = year + '-' + month + '-' + lastDay.getDate();

        this.getOrderListHistory({orderUserID:this.profile.id,searchtex:'',dateFrom:this.datePickFrom,dateTo:this.datePickTo});
    },
    methods: {
      ...mapActions(['getOrderListHistory','setOrderListSearchtext']),
      
      checkForm: function (e) {
        this.errors = [];
        e.preventDefault();
        
      },

      onBtnSubmit () {
        this.getOrderListHistory({orderUserID:this.profile.id,searchtex:'',dateFrom:this.datePickFrom,dateTo:this.datePickTo});
      }
     
    }
  }
</script>
